import BaseHotspot from "./BaseHotspot";

/**
 * Type of hotspot where the action is to display a audio popup
 */
export default class AudioHotspot extends BaseHotspot {
  /**
   * Initialises an audio hotspot based on a config object.
   *
   * @param config
   *
   * @example
   * {
   *   u: 0,
   *   v: 0.5,
   *   type: 'audio',
   *   icon: {
   *     name: 'Icon name',
   *     uuid: '...',
   *     url?: 'https://...'
   *   },
   *   options: {
   *     title: 'Title',
   *     audio-type: 'mp3',
   *     url: 'http://example.com/clip.mp3'
   *     content: 'transcript goes here'
   *   }
   * }
   */
  constructor(player, config) {
    super(player, config);

    this.loadIcon(config.icon, "audio.png");

    this._config = config;
  }
}
